var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20V14C14 12.3431 15.3431 11 17 11H26C27.6569 11 29 12.3431 29 14V20",
    stroke: "#160D02",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9384 18.3333C37.2396 18.3333 38.1943 19.556 37.8787 20.8183L34.8333 32.9999C34.6619 34.0508 34.2011 34.9932 33.5311 35.6632C32.8612 36.3331 32.0245 36.6882 31.1667 36.6666H12.8333C11.9755 36.6882 11.1388 36.3331 10.4689 35.6632C9.79889 34.9932 9.33809 34.0508 9.16667 32.9999L6.12127 20.8183C5.80569 19.556 6.76041 18.3333 8.06155 18.3333H35.9384Z",
    stroke: "#160D02",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCart;